import { Component, OnInit, ViewContainerRef,  OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { Subscription } from 'rxjs';

import { GlobalEventMangerService } from '../global-event-manger.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';

import { ToastrService } from 'ngx-toastr';
import {  ViewChild, ElementRef, Renderer2 } from '@angular/core';


@Component({
  selector: 'echexpayment-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [Modal]
})
export class LoginComponent implements OnInit, OnDestroy  {
  user: any = {};
  twofactor: any = {};
  otpvarification: any = {};
  public validationUser : boolean=false;
  public validationPassword : boolean=false;
  public invalidEmail : boolean=false;
  public twoFactor : boolean=false;
  public twilio : boolean=false;
  public validateotpform : boolean=false;
  public showloginform : boolean=true;
  NamecharacterLimitReached: { [key: string]: boolean } = {};
  
  busy: Subscription;
  
  constructor(private userService: UserService, private elementRef: ElementRef,private renderer: Renderer2, private toastr: ToastrService, private router: Router, vcRef: ViewContainerRef, public modal: Modal, private globalEventMangerService: GlobalEventMangerService, private localStorageService: LocalstorageService) { 
	//this.modal.defaultViewContainer = vcRef;
	
  }

  ngOnDestroy() {
    this.toastr.clear();
  }

  ngOnInit() {
	this.clearLocalStorage();
  }
  
  ngAfterViewInit() {
    this.renderer.selectRootElement('#Email_address').focus();
  }

  @ViewChild('submitButton') submitButton: ElementRef;
  moveNext(nextInput: HTMLInputElement, checkbox) {
	if(checkbox === 2){
		const saveButton = document.getElementById('submitButton') as HTMLElement;
		if (saveButton) {
		  saveButton.focus();
		  saveButton.click();
		}
	  } else{
		nextInput && nextInput.focus();
	  }
  }

  eventHandler(){
    this.validationUser = false;
    this.validationPassword = false;
    this.invalidEmail = false;
  }
  
  clearLocalStorage(){
	this.localStorageService.removeData('currentUser');
	this.localStorageService.removeData('currentUserToken');
	this.localStorageService.removeData('super_admin_detail');
	this.localStorageService.removeData('super_admin_token');

    this.globalEventMangerService.showNavBar(false);
    this.router.navigate(['/login']);
  }
  
  focusFirstInvalidControlPlus(): void {
	const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
	if (firstElementWithErrors) {
		firstElementWithErrors.focus();
	}
}
  // call Login api
   doLogin(data) {
	this.focusFirstInvalidControlPlus();   //focus field
	    if(data.valid){
			let model: any = data.value;
			let responseData = <any>{};
	     	this.busy = this.userService.login(model).subscribe(
			data => {
					this.localStorageService.setData("currentUserToken", data);
					this.getAuth(data);					
			},
			error => {
					responseData = error;
					this.toastr.error(responseData.error.message, 'Failed!');
			}
			);
		}
   }
   
   // get auth user data

   getAuth(data){
   let authData = <any>{};
	this.busy = this.userService.getAuthUser(data).subscribe(
        response => {
		authData = response;
		if(authData.data.google2fa_secret)
		{ 
			this.showloginform=false;
			this.twoFactor = true;
			
			setTimeout(() => {
				const businessNameElement = document.querySelector('#focus_entercode') as HTMLInputElement;
				if (businessNameElement) {
				  this.renderer.selectRootElement(businessNameElement).focus();
				}
			  }, 0); 
			return;
		}
		else
		{
			this.toastr.success('Login Success!', '');
			//this.showloginform=false;
			//this.twilio = true;
			//this.otpvarification.contact_type = authData.contact_type;
			//return;
		}
		
	
          
		setTimeout(()=>{

			this.localStorageService.setData("currentUser", authData.data);
			let parsed_currentUser = this.localStorageService.getData("currentUser");
			
			this.globalEventMangerService.showNavBar(true);

          if(parsed_currentUser.role_id=="3"){

            if(parsed_currentUser.status_id == '1'){

              this.router.navigate(['/dashboard']);
              this.modal.confirm()
                .size('sm')
                .title('CasherPay')
                .body(`Active free trial account ?`)
                .okBtn('Yes')
                .cancelBtn('Not now')
                .okBtnClass('btn btn-success')
                .cancelBtnClass('btn btn-warning')
               .open()
                .then( (resultPromise) => {
                    resultPromise.result.then( (result) => {
                       this.router.navigate(['/active-free-trial']);

                  }, 
                  () => {
                   console.log('Cancel');
                  } );
              });
            }
             if(parsed_currentUser.status_id == '3'){
				let current_UserToken = this.localStorageService.getData("currentUserToken");
				if(current_UserToken.data.is_steps_completed === false){
					this.router.navigate(['/get-started-deposits']);   //mergent login
				} else{
					this.router.navigate(['/dashboard']);   //mergent login
				}
            }

           if(parsed_currentUser.status_id == '2'){

            this.router.navigate(['/dashboard']);
            this.modal.confirm()
              .size('sm')
              .title('CasherPay')
              .body(`Activate your account now ?`)
              .okBtn('Yes')
              .cancelBtn('Not now')
              .okBtnClass('btn btn-success')
              .cancelBtnClass('btn btn-warning')
             .open()
              .then( (resultPromise) => {
                resultPromise.result.then( (result) => {
                 this.router.navigate(['/freetrial-to-active']);

                }, 
                () => {
                 console.log('Cancel');
                } );
            });
          }
           
          }

          if(parsed_currentUser.role_id == '1'){
             this.router.navigate(['/dashboard']);
          }

		  //Add Admin 
		  if(parsed_currentUser.role_id == '2'){
			if(parsed_currentUser.status_id == '3'){
		     	this.router.navigate(['/dashboard']);
			}
		  }
          
		  if(parsed_currentUser.role_id == '4'){
			if(parsed_currentUser.status_id == '3'){
				this.router.navigate(['/dashboard']);
			}
		 }
		}, 1500)
         
          
        },
      error => {
			authData = error;
			this.toastr.error(authData.error.message, 'Failed!');
      }
    );
  }

  togglePasswordVisibility(inputName: string) {
    const passwordInput = document.querySelector(`input[name="${inputName}"]`);
    const passwordToggle = passwordInput.nextElementSibling.querySelector('i');
  
    if (passwordInput.getAttribute('type') === 'password') {
      passwordInput.setAttribute('type', 'text');
      passwordToggle.classList.remove('fa-eye');
      passwordToggle.classList.add('fa-eye-slash');
    } else {
      passwordInput.setAttribute('type', 'password');
      passwordToggle.classList.remove('fa-eye-slash');
      passwordToggle.classList.add('fa-eye');
    }
  }
  
  // After Successfully enter code do login
  AfterGoogleAuth(data){
	
	this.localStorageService.setData("currentUser", data.data);
	let parsed_currentUser = this.localStorageService.getData("currentUser");
	this.globalEventMangerService.showNavBar(true);

	if(parsed_currentUser.role_id=="3" || parsed_currentUser.role_id=="4"){

	if(parsed_currentUser.status_id == '1'){

	  this.router.navigate(['/dashboard']);
	  this.modal.confirm()
		.size('sm')
		.title('CasherPay')
		.body(`Active free trial account ?`)
		.okBtn('Yes')
		.cancelBtn('Not now')
		.okBtnClass('btn btn-success')
		.cancelBtnClass('btn btn-warning')
	   .open()
		.then( (resultPromise) => {
			resultPromise.result.then( (result) => {
			   this.router.navigate(['/active-free-trial']);
		  }, 
		  () => {
		   console.log('Cancel');
		  } );
	  });
	}
	 if(parsed_currentUser.status_id == '3'){

	  this.router.navigate(['/dashboard']);
	}

	if(parsed_currentUser.status_id == '2'){

	this.router.navigate(['/dashboard']);
	this.modal.confirm()
	  .size('sm')
	  .title('CasherPay')
	  .body(`Activate your account now ?`)
	  .okBtn('Yes')
	  .cancelBtn('Not now')
	  .okBtnClass('btn btn-success')
	  .cancelBtnClass('btn btn-warning')
	 .open()
	  .then( (resultPromise) => {
		resultPromise.result.then( (result) => {
		 this.router.navigate(['/freetrial-to-active']);
		}, 
		() => {
		 console.log('Cancel');
		} );
	});
	}

	}

	if(parsed_currentUser.role_id == '1'){
	 this.router.navigate(['/dashboard']);
	}
  }
  // Validate enter code in two factor
  validateCode(resdata)
  {
	this.focusFirstInvalidControlPlus();   //focus field
	    if(resdata.valid){
			let model: any = resdata.value;
			var currentUser = this.localStorageService.getData("currentUserToken");
			var token =  currentUser.data.user_token;
			var data = {
				token:token,
				totp:model.totp
			};
		// Validate code after google auth
		let responseData = <any>{};
			this.busy = this.userService.validateCode(data).subscribe(
				data => {
					this.toastr.success('Login Success!', '');
					setTimeout(()=>{
						this.AfterGoogleAuth(data);
					},1500)
				},
				error => {
					responseData = error;
					this.toastr.error(responseData.error.message, 'Failed!');
				}
			);
		}
  }
  // get otp
  getOtp(model)
  {
	var currentUser = this.localStorageService.getData("currentUserToken");
	var token =  currentUser.token;
	var data = {
		token:token,
		otp_method:model.otp_method
	};
	let otpData = <any>{};
	this.busy = this.userService.getOtp(data).subscribe(
		response => {
			otpData = response;
			this.twilio = false;
			this.validateotpform = true;
			this.otpvarification.message = otpData.message;
		
		},
		error => {
			otpData = error;
			this.toastr.error(otpData.error.message, 'Failed!');		}
	);
  }
  // validate otp
  validateOtp(model)
  {
	var currentUser = this.localStorageService.getData("currentUserToken");
	var token =  currentUser.token;
	var data = {
		token:token,
		otp:model.otp
	};
	let responseData = <any>{};
	this.busy = this.userService.validateOtp(data).subscribe(
		data => {
			this.AfterGoogleAuth(data);
		},
		error => {
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
		}
	);
  }

    //Password validation
	containsUppercase(value: string): boolean {
		return /[A-Z]/.test(value);
	  }
	  
	  containsLowercase(value: string): boolean {
		return /[a-z]/.test(value);
	  }
	  
	  containsDigit(value: string): boolean {
		return /\d/.test(value);
	  }
	  
	  containsSpecialCharacter(value: string): boolean {
		return /[!@#$%^&*]/.test(value);
	  }
	

	  NameCharacterLimit(event: any, fieldName: string) {
		const maxTextLength = 40; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  return;
		}
	
		const inputValue = event.target.value;
	
		if (inputValue.length >= maxTextLength) {
		  if (allowedKeys.indexOf(inputChar) === -1) {
			this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
			setTimeout(() => {
			  this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
			}, 3000);
			event.preventDefault(); // Prevent entering the exceeded character
		  }
		}
	  }
	
	  isNameLimitReached(fieldName: string): boolean {
		return this.NamecharacterLimitReached[fieldName];
	  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/login/login.component.ts